// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Schb","title":"AfterFrontImage_title__XqdlS"};